import { render, staticRenderFns } from "./UserTableBadge.vue?vue&type=template&id=0291c038&scoped=true&"
import script from "./UserTableBadge.vue?vue&type=script&lang=js&"
export * from "./UserTableBadge.vue?vue&type=script&lang=js&"
import style0 from "./UserTableBadge.vue?vue&type=style&index=0&id=0291c038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0291c038",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
